// extracted by mini-css-extract-plugin
export default {"sectionTitle":"styles_sectionTitle__PDzt5","fullWidth":"styles_fullWidth__BeM2T","goalCard":"styles_goalCard__6o2uf"};